import React, { useEffect, useState, memo } from 'react';
import { useDispatch } from "react-redux";
import { setFetching } from '../../redux/states';
import { useErrorSetter } from '../../hooks/useUiMessages';
import { jobAutomatorPricing } from '../UI/SubscriptionPlans/data.js'
import { ModalContainerMobile } from '../../styled/Modal';
import Modal from '../UI/SubscriptionPlans/Modal';
import { fetchPrice, fetchCurrency } from '../../utils/client-functions';


//////This page contains CSS from HOME.CSS and INDEX.CSS
const ResumePricing = ({closePricing, open}) => {
    const dispatch = useDispatch()
    const [pricePerUse, setPricePerUse] = useState(0)
    const [pricePerWeek, setPricePerWeek] = useState(0)
    const [pricePerMonth, setPricePerMonth] = useState(0)
    const [currency, setCurrency] = useState('')

    const errorSetter = useErrorSetter();

    useEffect(() => {
        if (!open) return;

        dispatch(setFetching(true))
        const fetchData = async () => {
            try {
                const pricePerUse = await fetchPrice('resume', 'priceOne')
                const pricePerWeek = await fetchPrice('resume', 'priceTwo')
                const pricePerMonth = await fetchPrice('resume', 'priceThree')
                const userCurrency = await fetchCurrency()
                setPricePerUse(pricePerUse)
                setPricePerWeek(pricePerWeek)
                setPricePerMonth(pricePerMonth)
                setCurrency(userCurrency)
                sessionStorage.setItem('prevPath', window.location.pathname);
    
                dispatch(setFetching(false))
            } catch (error) {
                errorSetter('Error fetching country prices, please reload page')
            }

        }
        fetchData()
    }, [dispatch, open, errorSetter])

    if (!open) return null;

    const resumePricingDetails = jobAutomatorPricing(pricePerUse, pricePerWeek, pricePerMonth, currency);


    return (
        <ModalContainerMobile>
            <Modal plan={resumePricingDetails} title="Job Automator" open={true} setOpen={closePricing} />
        </ModalContainerMobile>
    )
}


export default memo(ResumePricing);